<template>
  <CSection title="保单详情">
    <h3>{{policy.productName}}</h3>
    <section class="section pt-4">
      <h4>企业及联系人信息</h4>
      <div>
        <v-layout class="section-row">
          <label class="label">企业名称：</label>
          <span>{{ policy.applicant.name }}</span>
        </v-layout>
        <v-layout class="section-row">
          <label class="label">企业证件号：</label>
          <span>{{ policy.applicant.identifyNumber }}</span>
        </v-layout>
        <v-layout class="section-row">
          <v-flex class="short-item">
            <label class="label">联系人姓名：</label>
            <span>{{ policy.applicant.contactName }}</span>
          </v-flex>
          <v-flex>
            <label class="label">联系人手机号：</label>
            <span>{{ policy.applicant.contactMobile }}</span>
          </v-flex>
        </v-layout>
        <v-layout class="section-row">
          <label class="label">联系邮箱：</label>
          <span>{{ policy.applicant.email }}</span>
        </v-layout>
        <v-layout class="section-row">
          <label class="label">联系地址：</label>
          <span>{{ policy.applicant.address }}</span>
        </v-layout>
      </div>
    </section>
    <hr class="line" />
    <section class="section">
      <h4>投保信息</h4>
      <div>
        <v-layout class="section-row">
          <v-flex class="short-item">
            <label class="label">生效日期：</label>
            <span>{{ policy.policy.effectDate }}</span>
          </v-flex>
          <v-flex class="short-item">
            <label class="label">保障期限：</label>
            <span>{{ policy.policy.insureStartDate }}</span>
          </v-flex>
        </v-layout>
      </div>
    </section>
    <hr class="line" />
    <section class="section">
      <h4>保障方案</h4>
      <div>
        <div>
          <v-data-table
            :headers="headers"
            :items="insureds"
            hide-actions
            class="c-insurance-plan simple-table"
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td>{{ props.item.name}}</td>
                <td v-if="props.item.relation === 1">本人</td>
                <td v-else-if="props.item.relation === 10">配偶</td>
                <td v-else-if="props.item.relation === 40">子女</td>
                <td>{{ props.item.identifyNumber }}</td>
                <td>{{getPlan(props.item.otherAttributeType) && getPlan(props.item.otherAttributeType).name}}</td>
                <td>{{props.item.price}}</td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </div>
    </section>
  </CSection>
</template>

<script>
export default {
  props: {
    policy: Object
  },
  data() {
    return {
      headers: [
        {
          text: "员工姓名",
          value: "name",
          sortable: false
        },
        {
          text: "与本人关系",
          value: "insuranceAmountList",
          sortable: false,
          width: "200"
        },
        {
          text: "身份证",
          sortable: false,
          width: "200"
        },
        {
          text: "产品方案",
          sortable: false,
          width: "200"
        },
        {
          text: "保费",
          sortable: false,
          width: "200"
        }
      ],
      planItmes:[]
    };
  },
  computed: {
    insureds(){
       return this.policy.insureds.filter(item => !item.isDelete)
    }
  },
  created () {
    this.$axios.get("/json/tk_ip.json").then(data => {
        this.planItmes = data;
    });    
  },
  methods: {
    getPlan(val){
      return this.planItmes.find(item => item.planId === val);
    },
  }
};
</script>